'use client'

import { useLogoutFlow } from '@/lib/commerce/hooks'

export default function Logout() {
  useLogoutFlow()
  return (
    <div className="w-full max-w-md">
      <h1 className="text-center text-foreground text-3xl font-semibold leading-7.5 tracking-[-0.7%]">Гарж байна</h1>
      <p className="mt-4 text-center text-muted-foreground leading-5">Таныг системээс гаргаж байна. Түр хүлээнэ үү...</p>
    </div>
  )
}
